export default __webpack_public_path__ + "static/media/welcome-bg7.fbefee95.png";